import React, { useState, useContext, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../payments.css";
import Navbar from "../../../../Shared/Navbar/Navbar";
import { ThemeContext } from "../../../../Shared/Themes/ThemeContext";
import { baseURL } from "../../../../Apiservices/Api";
import { AuthContext } from '../../../../AuthContext/AuthContext';
// import "./EditSupplier.css"; // Import your CSS file for styling

const A_EditSuppayment = () => {
  const { userId, userName } = useContext(AuthContext);
  const { paymentId } = useParams();
  const navigate = useNavigate();
  const { themeColor } = useContext(ThemeContext);
  const [collapsed, setCollapsed] = useState(false);
  const [totalPaid, setTotalPaid] = useState(0); // Total paid for lead + supplier



  const [supplierPayment, setSupplierPayment] = useState({
    supplierName: "",
    totalPayable: "",
    paidOn: "",
    paidAmount: "",
    balancePayment: "",
    comments: "",
    nextPayment: "",
    purposeOfPayment: "",
    supplierId: "",
    leadId: "",
    status: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");


  const fetchTotalPaid = async (leadId, supplierId) => {
    try {
      const response = await fetch(`${baseURL}/api/payment-summary?leadid=${leadId}&supplier_id=${supplierId}`);
      const result = await response.json();

      if (response.ok && result.length > 0) {
        const totalPaidValue = parseFloat(result[0].total_paid) || 0;
        setTotalPaid(totalPaidValue);
      }
    } catch (err) {
      console.error("Error fetching total paid amount:", err);
    }
  };

  useEffect(() => {
    const fetchPaymentDetails = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${baseURL}/api/edit-payment-log/${paymentId}`);
        const data = await response.json();
        console.log("API Response:", data);

        if (response.ok) {
          const payment = data.data;
          const paidOnDate = payment.paid_on ? new Date(payment.paid_on).toISOString().split('T')[0] : '';

          setSupplierPayment({
            leadId: payment.leadid,
            supplierName: "",
            totalPayable: payment.total_payable,
            paidOn: paidOnDate,
            paidAmount: payment.paid_amount || "",
            balancePayment: "",
            comments: payment.comments || "",
            nextPayment: "",
            purposeOfPayment: "",
            supplierId: payment.supplier_id || 1,
          });

          // fetch total excluding current
          fetchTotalPaid(payment.leadid, payment.supplier_id);


        } else {
          throw new Error(data.message || "Failed to fetch payment details");
        }


      } catch (err) {
        console.error("Error fetching payment details:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentDetails();
  }, [paymentId]);
  const handleChange = (e) => {
    const { name, value } = e.target;

    setSupplierPayment((prev) => {
      const updatedPayment = {
        ...prev,
        [name]: value,
      };

      if (name === "totalPayable" || name === "paidAmount") {
        const totalPayable = parseFloat(updatedPayment.totalPayable) || 0;
        const paidAmount = parseFloat(updatedPayment.paidAmount) || 0;
        const balance = totalPayable - (totalPaid - paidAmount);
        updatedPayment.balancePayment = balance >= 0 ? balance.toString() : "0";
      }

      return updatedPayment;
    });
  };


  const handleUpdatePayment = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const paymentData = {
        leadId: supplierPayment.leadid,
        paidAmount: supplierPayment.paidAmount,
        paidOn: supplierPayment.paidOn,
        comments: supplierPayment.comments,
        // userid: userId,
        //username: "Admin",
       // status: "Approved",
       username: userName,
        status: "Pending",
      };

      const response = await fetch(`${baseURL}/api/update-suppliers-payment/${paymentId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(paymentData),
      });

      if (!response.ok) {
        throw new Error("Failed to update payment");
      }

      navigate(`/a-supplier/${supplierPayment.leadId}`);

    } catch (err) {
      console.error("Error updating payment:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="salesViewLeadsContainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`salesViewLeads ${collapsed ? "collapsed" : ""}`}>
        <div className="addpayment-form-container">
          <h2 className="addpayment-form-header" style={{ "--theme-color": themeColor }}>
            Edit Supplier Payment - Lead ID: {supplierPayment.leadId}
          </h2>


          {error && <div className="alert alert-danger">{error}</div>}



          <div
            className="payment-summary"
            style={{
              margin: "20px 0",
              backgroundColor: "#f9f9f9",
              border: "1px solid #ddd",
              padding: "15px",
              borderRadius: "8px",
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",

            }}
          >
            <p>
              <strong>Total Payable:</strong> ₹{supplierPayment.totalPayable || 0}
            </p>
            <p>
              <strong>Total Paid (excluding current):</strong> ₹
              {(totalPaid - (parseFloat(supplierPayment.paidAmount) || 0)).toLocaleString()}
            </p>
            <p>
              <strong>Balance:</strong>{" "}
              <span
                style={{
                  color:
                    (parseFloat(supplierPayment.totalPayable) || 0) -
                      (totalPaid - (parseFloat(supplierPayment.paidAmount) || 0)) >
                      0
                      ? "red"
                      : "green",
                }}
              >
                ₹
                {(
                  (parseFloat(supplierPayment.totalPayable) || 0) -
                  (totalPaid - (parseFloat(supplierPayment.paidAmount) || 0))
                ).toLocaleString()}
              </span>
            </p>
          </div>




          <form onSubmit={handleUpdatePayment} className="addpayment-form">
            <div className="addpayment-form-grid">


              <div className="addpayment-input-group">
                <label>Paid On</label>
                <input
                  type="date"
                  name="paidOn"
                  value={supplierPayment.paidOn || ""}
                  onChange={handleChange}
                />
              </div>

              <div className="addpayment-input-group">
                <label>Paid Amount</label>
                <input
                  type="number"
                  name="paidAmount"
                  placeholder="Enter paid amount"
                  value={supplierPayment.paidAmount || ""}
                  onChange={handleChange}
                />
              </div>

              <div className="addpayment-input-group full-width">
                <label>Comments</label>
                <textarea
                  name="comments"
                  placeholder="Enter comments"
                  value={supplierPayment.comments || ""}
                  onChange={handleChange}
                  rows="3"
                />
              </div>
            </div>

            <div className="addpayment-form-footer">
              <button
                className="btn btn-secondary"
                type="button"
                onClick={() => navigate(-1)}
                disabled={loading}
              >
                Back
              </button>
              <button
                className="btn btn-primary"
                type="submit"
                disabled={loading}
              >
                {loading ? "Updating..." : "Update Payment"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default A_EditSuppayment;